import { RecHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const PostProgramLevelRenewalData = (programLevelInstanceId, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    let newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const programLevelInstanceIdForUrl = programLevelInstanceId ? encodeURIComponent(programLevelInstanceId) : 'NaN';
    const url = `/ProgramLevelInstance/${programLevelInstanceIdForUrl}/Renew`;
    RecHttpHelper(url, 'POST')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isSaving: false,
            isSaved: true,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isSaving: false,
          isSaved: false,
          isArrayLoaded: false,
          message: message
        });
      });
  };
};

export default PostProgramLevelRenewalData;